// extracted by mini-css-extract-plugin
export default {"textLayer":"textLayer__1Nsf6"};